import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BadgeCheckIcon, XIcon } from 'lucide-react';
import { buyers, images } from '../../data/content';
import type { Buyer } from '../../types/content';
type Notice = Buyer & {
  minutes: number;
  key: number;
};
export function PurchasePopup() {
  const [notice, setNotice] = useState<Notice | null>(null);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let index = Math.floor(Math.random() * buyers.length);
    let hideTimer: number | undefined;
    const show = () => {
      index = (index + 1 + Math.floor(Math.random() * 3)) % buyers.length;
      setNotice({
        ...buyers[index],
        minutes: 1 + Math.floor(Math.random() * 9),
        key: Date.now()
      });
      hideTimer = window.setTimeout(() => setNotice(null), 5000);
    };
    const first = window.setTimeout(show, 6000);
    const loop = window.setInterval(show, 15000);
    return () => {
      window.clearTimeout(first);
      window.clearInterval(loop);
      if (hideTimer) window.clearTimeout(hideTimer);
    };
  }, [dismissed]);
  return <div className="pointer-events-none fixed inset-x-3 bottom-[92px] z-50 sm:inset-x-auto sm:bottom-6 sm:left-6 sm:w-[360px]" aria-live="polite" data-id="element-397" data-mp="2yycb0k4xsezs">
      <AnimatePresence data-id="element-398" data-mp="38wrsrwi2qbwm">
        {notice && !dismissed && <motion.div key={notice.key} className="pointer-events-auto relative flex items-center gap-3 rounded-2xl bg-white p-3 pr-9 text-ink shadow-[0_12px_40px_rgba(8,24,51,0.35)] ring-1 ring-black/5" initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-399" data-mp="38u5me06x62fz">
            <img src={images.mockup} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-navy object-contain p-1" data-id="element-400" data-mp="i006mpuxhep" />
            <div className="min-w-0" data-id="element-401" data-mp="5frq5b6xytg9">
              <p className="text-sm leading-snug" data-id="element-402" data-mp="3bwihcoru3ppn">
                <span className="font-bold" data-id="element-403" data-mp="3bx1pxevlh1r0">{notice.name}</span> from <span className="font-bold" data-id="element-404" data-mp="36y77wf5gbh7y">{notice.country}</span>
              </p>
              <p className="text-sm leading-snug text-muted" data-id="element-405" data-mp="3lmlcauiindqm">just purchased the Dental Implant Clinical Roadmap™</p>
              <p className="mt-0.5 flex items-center gap-1 text-xs font-semibold text-cta-shadow" data-id="element-406" data-mp="3gvbl3phbk2cm">
                <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-407" data-mp="3umqf0rcrlnyg" />
                {notice.minutes} min ago · Verified purchase
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-md p-1 text-muted transition-colors duration-150 hover:bg-paper hover:text-ink" aria-label="Dismiss notification" data-id="element-408" data-mp="8g1o2vsadnbp">
              <XIcon className="h-4 w-4" data-id="element-409" data-mp="2a99bytlytd97" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}